import React from 'react';
import styled from 'styled-components';

import { Modal, Text, theme } from 'components';
import { useBreakpoint } from 'hooks';
import { detectMobileDevice } from 'utils';
import { zPositions } from '@/constants';
import { SUPRA_EKEY_LINK, SUPRA_LOGO_URL } from '../../constants';

type SupraAccessProps = {
  isSupraLockbox?: boolean;
};

const SupraAccessContainer: React.FC<SupraAccessProps> = ({
  isSupraLockbox,
  children,
}) =>
  // if isSupraLockbox, use deeplink to open mobile app
  detectMobileDevice() ? (
    <a href={SUPRA_EKEY_LINK}>{children}</a>
  ) : (
    <StyledNoLinkContainer
      onClick={() =>
        Modal.error({
          centered: true,
          content: 'To access Supra, you must do so from your mobile device.',
          okText: 'Done',
          title: 'Mobile-only access',
          zIndex: zPositions.tourModal + 1,
        })
      }
    >
      {children}
    </StyledNoLinkContainer>
  );

const SupraAccess: React.FC<SupraAccessProps> = ({ isSupraLockbox }) => {
  const { md } = useBreakpoint();

  const ImageAndTexts = (
    <>
      <StyledImageContainer $md={md}>
        <StyledImage src={SUPRA_LOGO_URL} alt="supra logo" />
      </StyledImageContainer>
      <TextContainer $md={md}>
        {md && <AccessText>Access</AccessText>}
        {!isSupraLockbox && <Text strong>eKEY App</Text>}
      </TextContainer>
    </>
  );

  return (
    <SupraAccessContainer isSupraLockbox={isSupraLockbox}>
      <StyledContainer>
        {md ? (
          ImageAndTexts
        ) : (
          <StyledResponsiveContainer>{ImageAndTexts}</StyledResponsiveContainer>
        )}
        <StyledIconContainer>
          <i className="fa fa-chevron-right" color="#ffeeff"></i>
        </StyledIconContainer>
      </StyledContainer>
    </SupraAccessContainer>
  );
};

export default SupraAccess;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 18px;
  max-width: 300px;
  min-width: 200px;
  background-color: white;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
  color: ${theme.gray4};
`;

const StyledResponsiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: space-between;
`;

const StyledImageContainer = styled.div<{ $md: boolean }>`
  width: ${props => (props.$md ? '70px' : '50px')};
`;

const StyledImage = styled.img`
  width: 100%;
  object-fit: contain;
`;

const TextContainer = styled.div<{ $md: boolean }>`
  display: flex;
  flex-direction: column;
  ${props => !props.$md && 'font-size: 8px;'}
`;

const AccessText = styled(Text)`
  color: #5d7198;
`;

const StyledIconContainer = styled.div`
  display: flex;
  color: ${theme.blue5};
  height: 100%;
  align-items: center;
`;

const StyledNoLinkContainer = styled.div`
  cursor: pointer;
`;
